import React from 'react';
import moment from 'moment';
import get from 'lodash/get';
import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';
import { connect } from 'react-redux';

import {
  Row,
  Col,
  Layout,
  Form,
  Input,
  Select,
  Icon,
  Radio,
  Button,
  DatePicker,
  Alert,
  Modal,
  Switch,
  message, Tooltip
} from 'antd';

import {
  createSAERequest,
  updateSAERequest,
  toggleActivateSAERequest,
  deleteSAERequest,
  getSitesRequest, lockSAERequest, unlockSAERequest
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getSAEUpdatePermissionBySite,
  getSAEUpdatePermission,
  getSAEDeletePermissionBySite,
  getSAELockPermission,
  getSAEUnlockPermission, getUserTimezone, getUserShortTimezone,
} from "../../reducers/user/selectors";

import classes from './SAEReportingForm.css';
import { withNamespaces } from 'react-i18next';

const { Option } = Select;


class SAEReportingForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      requestResult: {},
      wasCreated: false,
      saeState: '',
      subjectID: '',
      id: '',
      deleteSubmitModal: false,
      sites: [],
      locked: false,
    };
  }

  async componentDidMount() {
    this.setState({ saeState: this.props.state, locked: get(this.props, 'locked') });

    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) { if (e.response.status === 401) { this.props.logout();  return; } console.log(e); }
  }

  handleSubmit = e => {
    e.preventDefault();

    const { SAEUpdatePermissionBySite, SAEUpdatePermission } = this.props;

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        if (this.props.sae_date && !SAEUpdatePermissionBySite) { return; }
        if ((this.props.sae_date || this.state.wasCreated) && !SAEUpdatePermission) { return; }

        this.setState({ isLoading: true });
        try {
          const sae = cloneDeep(values);
          if (values.sae_date) {
            const date = cloneDeep(values.sae_date);
            sae.sae_date = moment.tz(date.format('YYYY-MM-DDT') + '12:00', this.props.userTimezone || get(find(this.state.sites, ({ id }) => id === this.props.form.getFieldValue('site_id')), 'time_zone') || 'UTC').utc().format('YYYY-MM-DDTHH:mm');
          }

          sae.is_sae_occurred = values.is_sae_occurred === 'true' ? true : values.is_sae_occurred === 'false' ? false : null;
          sae.is_adverse_event_expected = values.is_adverse_event_expected === 'true' ? true : values.is_adverse_event_expected === 'false' ? false : null;
          sae.suadr = values.suadr || undefined;
          sae.subjectID = undefined;
          sae.site_id = +sae.site_id || get(this.props, 'site.id');

          if (this.props.sae_date || this.state.wasCreated) {
            await updateSAERequest(get(this.props, 'subject.code', this.state.subjectID), get(this.props, 'id', this.state.id), sae);
            this.setState({ isLoading: false, requestResult: { type: 'success', message: this.props.i18n.t('Success') } });
          } else {
            const { data } = await createSAERequest(this.props.form.getFieldValue('subjectID'), sae);
            this.setState({ wasCreated: true, id: data.id, subjectID: this.props.form.getFieldValue('subjectID') });
          }

          this.setState({ isLoading: false, requestResult: { type: 'success', message: this.props.i18n.t('Success') } });
        } catch (e) {
          console.log(e.response);
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', get(e, 'response.data.error', this.props.i18n.t('Error'))) } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });

            this.props.form.setFields(errors);

          }
        }
      }
    });
  };

  toggleActivate = async () => {
    try {
      await toggleActivateSAERequest(get(this.props, 'subject.code', this.state.subjectID), get(this.props, 'id', this.state.id), this.state.saeState);
      this.setState({ requestResult: { type: 'success', message: this.props.i18n.t('Success') }, saeState: this.state.saeState === 'inactive' ? 'active' : 'inactive' });
      this.hideDeleteModal();
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout(); }
    }
  };

  deleteSae = async () => {
    const { SAEDeletePermission } = this.props;

    if (SAEDeletePermission) {
      try {
        await deleteSAERequest(this.props.subjectID, this.props.id);
        this.props.onDelete();
      } catch (e) {
        if (get(e, 'response.status') === 401) { this.props.logout(); }
      }
    }
  };

  showDeleteModal = () => { this.setState({ deleteSubmitModal: true }); };
  hideDeleteModal = () => { this.setState({ deleteSubmitModal: false }); };

  handleSiteIDChange = async (val) => {
    this.setState({ siteID: val, responseMessage: '', sae: null }, this.searchSae);
  };

  onSwitchLock = async () => {
    try {
      if (this.state.locked) {
        await unlockSAERequest(get(this.props, 'subject.code', this.state.subjectID), get(this.props, 'id', this.state.id));
        this.setState({ locked: false });
      } else {
        await lockSAERequest(get(this.props, 'subject.code', this.state.subjectID), get(this.props, 'id', this.state.id));
        this.setState({ locked: true });
      }
      message.success(this.props.i18n.t('Saved'));
    } catch(e) {
      message.error(get(e, 'response.data.error', this.props.i18n.t('Error')));
    }
  };

  render() {
    const { isLoading, requestResult, wasCreated, deleteSubmitModal, sites, locked } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { SAEDeletePermission, SAEUpdatePermissionBySite, SAEUpdatePermission, SAELockPermission, SAEUnlockPermission } = this.props;

    let isEventTypeOther = getFieldValue('event_type') ? this.props.form.getFieldValue('event_type') === 'other' : this.props.event_type === 'other';
    let isSAEOccured = getFieldValue('is_sae_occurred') === 'true';
    let isAdverseEventExpected = getFieldValue('is_adverse_event_expected') === 'true';

    const isEditing = this.state.wasCreated ? SAEUpdatePermission : this.props.sae_date ? SAEUpdatePermissionBySite && !locked : true;

      return (
          <div className={classes.wrapper}>
            <Form onSubmit={this.handleSubmit}>
              <h4 className='headline-default'>{this.props.i18n.t('Has a SAE occurred?')}</h4>

              <div>
                <Form.Item>
                  {getFieldDecorator('is_sae_occurred', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: this.props.is_sae_occurred ? this.props.is_sae_occurred.toString() : 'false'
                  })(
                    <Radio.Group disabled={!isEditing}>
                      <Radio value='true'>{this.props.i18n.t('Yes')}</Radio>
                      <Radio value='false'>{this.props.i18n.t('No')}</Radio>
                    </Radio.Group>,
                  )}
                </Form.Item>
              </div>

              <Row gutter={12}>
                <Col lg={12}>
                  <label>
                    <b>{this.props.i18n.t('Subject ID')}:</b>
                    <Form.Item>
                      {getFieldDecorator('subjectID', {
                        rules: [{ required: true, message: 'Required' }],
                        initialValue: get(this.props, 'subject.code', '')
                      })(
                        <Input disabled={!isEditing || !!(this.props.sae_date || wasCreated)} />
                      )}
                    </Form.Item>
                  </label>
                </Col>
                <Col lg={12}>
                  <label>
                    <b>{this.props.i18n.t('Site ID')}</b>
                    <Form.Item>
                      {getFieldDecorator('site_id', {
                        rules: [{ required: true, message: this.props.i18n.t('Required') }],
                        initialValue: get(this.props, 'site.id')
                      })(<Select disabled={!isEditing} placeholder={this.props.i18n.t('Select Site ID')} style={{ width: '100%'}} allowClear>
                        {sites.map(site => (
                          <Option key={site.id} value={site.id}>{site.name}</Option>
                        ))}
                      </Select>)}
                    </Form.Item>
                  </label>
                </Col>
              </Row>

              {isSAEOccured && <div>
                <p>
                  {this.props.i18n.t('NamespaceSAEReportingForm:An expected adverse event is one that is a known complication of the disease or treatment under study. For example, aspiration pneumonia, seizure, UTI, symptomatic ICH area known (expected) serious complication of stroke and its treatment. The underlying cause of the event is not considered when determining if an event is expected or not.')}
                </p>

                <Row gutter={12}>
                  <Col lg={12}>
                    <b>{this.props.i18n.t('NamespaceSAEReportingForm:Was the adverse event expected?')}</b>
                    <Form.Item>
                      {getFieldDecorator('is_adverse_event_expected', {
                        rules: [{ required: true, message: 'Required' }],
                        initialValue: this.props.is_adverse_event_expected !== undefined && this.props.is_adverse_event_expected !== null ? this.props.is_adverse_event_expected.toString() : 'null'
                      })(
                        <Radio.Group disabled={!isEditing}>
                          <Radio value='true'>{this.props.i18n.t('Yes')}</Radio>
                          <Radio value='false'>{this.props.i18n.t('No')}</Radio>
                          <Radio value='null'>{this.props.i18n.t('Unknown')}</Radio>
                        </Radio.Group>,
                      )}
                    </Form.Item>

                    <br/>

                    <label>
                      <b>{this.props.i18n.t('NamespaceSAEReportingForm:If expected, please indicate type of event')}</b>
                      <Form.Item>
                        {getFieldDecorator('event_type', {
                          rules: [{ required: isAdverseEventExpected, message: this.props.i18n.t("Required") }],
                          initialValue: this.props.event_type
                        })(
                          <Select disabled={!isEditing} placeholder={this.props.i18n.t('NamespaceSAEReportingForm:Select type of event')}>
                            <Option value="symptomatic_intracerebral">{this.props.i18n.t('NamespaceSAEReportingForm:Symptomatic intracerebral hemorrhage')}</Option>
                            <Option value="peripheral_bleeding">{this.props.i18n.t('NamespaceSAEReportingForm:Peripheral bleeding requiring blood transfusion')}</Option>
                            <Option value="angioedema">{this.props.i18n.t('Angioedema')}</Option>
                            <Option value="other">{this.props.i18n.t('NamespaceSAEReportingForm:Others (give diagnosis, if possible)')}</Option>
                            <Option value="none">{this.props.i18n.t('None')}</Option>
                          </Select>
                        )}
                      </Form.Item>
                    </label>
                  </Col>
                  <Col lg={12}>
                    <label>
                      <b>{this.props.i18n.t("Date")}</b>
                      <Form.Item>
                        <div style={{ display: 'flex', alignItems: 'center', width: '340px' }}>
                          {getFieldDecorator('sae_date', {
                            rules: [{ required: true, message: this.props.i18n.t("Required") }],
                            initialValue: this.props.sae_date ? moment.utc(this.props.sae_date).tz(this.props.userTimezone || get(find(sites, ({ id }) => id === getFieldValue('site_id')), 'time_zone') || 'UTC') : moment.utc(new Date()).tz(this.props.userTimezone || get(find(sites, ({ id }) => id === getFieldValue('site_id')), 'time_zone') || 'UTC')
                          })(
                            <DatePicker
                              disabled={!isEditing}
                              format='YYYY/MM/DD'
                              disabledDate={(currentDate) => currentDate.diff(moment.now()) > 86400000} />,
                          )}

                          <span style={{width: '35px'}}>
                            &nbsp;{this.props.userShortTimezone || get(find(sites, ({ id }) => id === getFieldValue('site_id')), 'short_tz') || 'UTC'}
                          </span>
                        </div>
                      </Form.Item>
                    </label>

                    <br/>

                    {isEventTypeOther && (<label>
                      <b>{this.props.i18n.t('NamespaceSAEReportingForm:If other, please indicate what event occurred')}:</b>
                      <Form.Item>
                        {getFieldDecorator('other_event_comments', {
                          rules: [{ required: true, message: this.props.i18n.t('Required') }],
                          initialValue: this.props.other_event_comments
                        })(
                          <Input.TextArea disabled={!isEditing} />
                        )}
                      </Form.Item>
                    </label>)}
                  </Col>
                </Row>

                <label>
                  {this.props.i18n.t('SAE comments')}
                  <br/>
                  <Form.Item>
                    {getFieldDecorator('event_comments', {
                      initialValue: this.props.event_comments || ''
                    })(
                      <Input.TextArea disabled={!isEditing} rows="3" />
                    )}
                  </Form.Item>
                </label>

                <p>{this.props.i18n.t('NamespaceSAEReportingForm:If the adverse event was serious, unexpected and related, it is a Serious Unexpected Adverse Drug Reaction (SUADR). Please report details in narrative review form bellow.')}</p>

                <h4 className='headline-default'>{this.props.i18n.t('NamespaceSAEReportingForm:Serious Unexpected Adverse Drug Reaction (SUADR)')}</h4>

                <p>
                  {this.props.i18n.t('NamespaceSAEReportingForm:NARRATIVE/DETAILS')}
                  <br/>
                  {this.props.i18n.t('NamespaceSAEReportingForm:Please describe the SUADR, treatment and outcome. Please also include relevant medical history, any relevant abs or tests performed, and any medications given to the patient. Please describe the resolution of the event (continuing, resolved, death).')}
                </p>

                <Form.Item>
                  {getFieldDecorator('other_comments', {
                    initialValue: this.props.other_comments || ''
                  })(
                    <Input.TextArea disabled={!isEditing} rows="6" />
                  )}
                </Form.Item>
              </div>}


              {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

              <Form.Item className={classes.formActions}>
                <Button type="default" size="large" htmlType="button" onClick={this.props.onCancel}>
                  {this.props.i18n.t('Back')}
                </Button>
                &nbsp;&nbsp;

                {(this.props.sae_date || this.state.wasCreated) && <Tooltip placement="topLeft" title={this.props.i18n.t("Lock / Unlock the SAE record")}>
                  {this.props.i18n.t('NamespaceSAEReportingForm:Lock status')}: &nbsp;
                  <Switch disabled={((!SAEUnlockPermission && locked) || (!SAELockPermission && !locked))} checked={!locked} onChange={this.onSwitchLock} />
                </Tooltip>}

                {/*<Button type="danger" size="large" htmlType="button" style={{ backgroundColor: '#f00', borderColor: '#f00', color: '#fff' }} onClick={this.deleteSae}>
                  {this.props.i18n.t('Delete')}
                </Button>*/}
                {this.props.sae_date && !wasCreated && SAEDeletePermission && isEditing && <Button type="default" size="large" htmlType="button" style={{ backgroundColor: '#f56009', borderColor: '#f56009',  color: '#fff' }} onClick={this.showDeleteModal}>
                  {this.state.saeState === 'inactive' ? this.props.i18n.t('Activate') : this.props.i18n.t('Deactivate')}
                </Button>}
                {isEditing && <Button type="primary" size="large" htmlType="submit">
                  {this.props.i18n.t('Save')}
                  {isLoading && <Icon type="loading" />}
                </Button>}
              </Form.Item>
            </Form>

            <Modal
              title={`SAE ${this.state.saeState === 'inactive' ? this.props.i18n.t('Activate') : this.props.i18n.t('Deactivate')}`}
              visible={deleteSubmitModal}
              onOk={this.toggleActivate}
              onCancel={this.hideDeleteModal}
            >
              <p>{this.props.i18n.t('NamespaceSAEReportingForm:Confirm SAE')} {this.state.saeState === 'inactive' ? this.props.i18n.t('activate') : this.props.i18n.t('deactivate')} {this.props.i18n.t('action')}</p>
            </Modal>
          </div>
      );
    }
}

const mapStateToProps = (state, props) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  SAEUpdatePermission: getSAEUpdatePermission(state),
  SAEUpdatePermissionBySite: getSAEUpdatePermissionBySite(get(props, 'site.id'))(state),
  SAEDeletePermission: getSAEDeletePermissionBySite(get(props, 'site.id'))(state),
  SAELockPermission: getSAELockPermission(state),
  SAEUnlockPermission: getSAEUnlockPermission(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'saeReporting' })(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SAEReportingForm)));



// WEBPACK FOOTER //
// ./src/components/SAEReportingForm/SAEReportingForm.js